import { render, staticRenderFns } from "./ParentComponent.vue?vue&type=template&id=12227c6f&"
import script from "./ParentComponent.vue?vue&type=script&lang=js&"
export * from "./ParentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports